import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ResetPrasadDialog = ({ open, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <div
      className="modal-header"
      style={{
        background: "#1976D2",
        color: "white",
        fontWeight: "bold",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px",
        borderBottom: "1px solid #ddd",
      }}
    >
      <DialogTitle>Reset Prasad</DialogTitle>
      <IconButton onClick={onClose} color="dark" data-log="Close Icon Button">
        <CloseIcon sx={{ color: "white" }} />
      </IconButton>
    </div>
    <DialogContent>
      <Typography>
        Are you sure you want to reset all donors' Prasad <br />
        <b style={{ color: "green" }}>Yes </b> to{" "}
        <b style={{ color: "red" }}> No </b>?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="inherit">
        No
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained">
        Yes, Reset
      </Button>
    </DialogActions>
  </Dialog>
);

export default ResetPrasadDialog;
